import type { postTestimonialsLinkResponse } from '@lt/api/dist/methods/testimonials/types';
import { api } from 'src/api';
import type { AxiosError } from 'axios';

export type UseTestimonialsLink = ReturnType<typeof useTestimonialsLink>;

export const useTestimonialsLink = () => {
  const handleLinkClientToTestimonials = async (
    testimonial_id: number,
    client_id: number,
  ): Promise<postTestimonialsLinkResponse | AxiosError> => {
    try {
      const data = {
        testimonial_id,
        client_id,
      };
      return api.postTestimonialsLink(data);
    } catch (e: any) {
      console.dir(e);
      return e;
    }
  };

  return {
    handleLinkClientToTestimonials,
  };
};
